export enum StorageConstants {
  PLAYER_NAME = "PLAYER_NAME",
  VOLUME = "VOLUME",
  THEME_IS_DARK = "THEME_IS_DARK",
  GAME_SETTINGS = "GAME_SETTINGS",
  SETTINGS_GRID_SIZE = "SETTINGS_GRID_SIZE",
  SETTINGS_ROWS = "SETTINGS_ROWS",
  SETTINGS_COLS = "SETTINGS_COLS",
  SETTINGS_TARGET_TOTAL_SCORE = "SETTINGS_TARGET_TOTAL_SCORE",
  SETTINGS_TARGET_ROUND_SCORE = "SETTINGS_TARGET_ROUND_SCORE",
  SETTINGS_SHOW_TARGET_ICONS = "SETTINGS_SHOW_TARGET_ICONS",
}

export enum GlobalConstants {
  VOLUME_STEP = 10,
}

export const Constants = {
  GAME_STATUS_DEFAULT: "Find the following heroes:",
};

export enum MediaQueries {
  XS = "(min-width: 476px)",
  SM = "(min-width: 576px)",
  MD = "(min-width: 768px)",
  LG = "(min-width: 992px)",
  XL = "(min-width: 1200px)",
}
